import "./Services.css";
import Button from "../button/Button";
import { Link, useNavigate } from "react-router-dom";
const Services = () => {

  return (
    <div id="service-progressive" className="progressive-wrapper">
       <div className="Container-main">
        <div className="serviceContent">
          
           <h2>Your Ideal PWA Is Just a Conversation Away</h2>
          <p>
          Connect with a progressive web app development company that truly understands your goals. We help you shape a fast, modern, and scalable PWA built around what your business actually needs.
</p>
          <div><Link to='/contact_us' className="link"><Button  arrowColor="purple" text="Get Your Free Project Review Today"/></Link></div>
        </div>
     </div>
    </div>
  );
};

export default Services;
